import { createFileRoute } from "@tanstack/react-router";
import { InstagramLandingPage } from "@/components/pages/InstagramLandingPage";

const SITE = "https://kentro.com.br";

const META = {
  en: {
    title: "Kentro Sistemas Inteligentes | Support and Sales on Instagram and WhatsApp",
    desc: "Reply to Direct and WhatsApp in one place with AI, CRM and automation. Turn followers into customers with Kentro.",
    ogTitle: "Kentro: Direct + WhatsApp + AI to sell more",
    ogDesc: "Centralize Instagram, WhatsApp and CRM with AI. Reply faster and turn conversations into sales.",
  },
  es: {
    title: "Kentro Sistemas Inteligentes | Atención y Ventas en Instagram y WhatsApp",
    desc: "Responde Direct y WhatsApp en el mismo lugar con IA, CRM y automatización. Convierte seguidores en clientes con Kentro.",
    ogTitle: "Kentro: Direct + WhatsApp + IA para vender más",
    ogDesc: "Centraliza Instagram, WhatsApp y CRM con IA. Atiende más rápido y convierte conversaciones en ventas.",
  },
} as const;

export const Route = createFileRoute("/$locale/instagram")({
  head: ({ params }) => {
    const loc: "en" | "es" = params.locale === "es" ? "es" : "en";
    const m = META[loc];
    return {
      meta: [
        { title: m.title },
        { name: "description", content: m.desc },
        { property: "og:title", content: m.ogTitle },
        { property: "og:description", content: m.ogDesc },
        { property: "og:url", content: `${SITE}/${loc}/instagram` },
        { property: "og:locale", content: loc === "es" ? "es_ES" : "en_US" },
      ],
      links: [
        { rel: "canonical", href: `${SITE}/${loc}/instagram` },
        { rel: "alternate", hrefLang: "pt-BR", href: `${SITE}/instagram` },
        { rel: "alternate", hrefLang: "en", href: `${SITE}/en/instagram` },
        { rel: "alternate", hrefLang: "es", href: `${SITE}/es/instagram` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE}/instagram` },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: loc === "es" ? "Inicio" : "Home", item: `${SITE}/${loc}/` },
              { "@type": "ListItem", position: 2, name: 'Instagram', item: `${SITE}/${loc}/instagram` },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": 'WebPage',
            "@id": `${SITE}/${loc}/instagram`,
            url: `${SITE}/${loc}/instagram`,
            name: m.title,
            description: m.desc,
            inLanguage: loc === "es" ? "es" : "en",
            isPartOf: { "@type": "WebSite", "@id": `${SITE}/#website` },
          }),
        },
      ],
    };
  },
  component: InstagramLandingPage,
});
